<template>
  <div class="page-box">
    <div class="nav-search justify-between align-center" @click="drawer = true">
      <img class="nav-logo" :src="$baseUrl + llll.logo" alt />
      <img class="nav-logo-right" src="../assets/img/more.png" alt />
    </div>
    <router-view :key="$route.path + $route.query.id"></router-view>
    <div class="nav-footer justify-between align-center">
      <div class="footer-logo-box flex-col">
        <span @click="jumpLogin(2)" style="cursor: pointer">基地登录</span>
        <span>{{ llll.copyrightNo || "" }}</span>
        <a href="https://beian.miit.gov.cn" target="_blank"
            >备案号 : 蒙ICP备2024019624号-1</a
          >
        <!-- <a href="http://beian.miit.gov.cn" target="_blank"
          >备案号：{{ llll.recordNo || "" }}</a
        > -->
        <!-- <span>技术支持：一秋科技</span> -->
        <span style="white-space: pre-wrap; text-align: justify"
          >{{ this.$wangzhan.name == "安徽" ? "学会地址" : "协会地址" }} ：{{
            llll.real_address || ""
          }}</span
        >
      </div>
      <div class="footer-code-box flex-col align-center">
        <img :src="$baseUrl + llll.twoDimensionalCode" alt />
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      direction="ltr"
      :show-close="false"
      title="菜单"
      size="50%"
    >
      <div class="app-menu">
        <div class="app-menu-item" v-if="login_status">
          <span @click="outLogin()">退出登录</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span @click="renew()" v-if="tab === '0' || tab === '3'">续费</span>
        </div>
        <div v-else>
          <div class="app-menu-item">
            <span @click="jumpLogin(0)">登录</span>
            <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span @click="jumpLogin(1)">注册</span>
          </div>
          <div class="app-menu-item">
            <span @click="jumpLogin(3)">会员单位注册</span>
          </div>
        </div>
        <div class="app-menu-item">
          <span @click="jumpRouter('/indexPage')">首页</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span @click="jumpRouter('/searchPage')">搜索</span>
        </div>
        <div
          class="app-menu-item"
          v-for="(item, index) in tabbar_list"
          :key="index"
          v-if="item.path != '/matrixPage' || identity == 'admin'"
          @click="jumpRouter(item.path)"
        >
          <span
            :class="
              selfPath == item.path && !item.child ? 'app-menu-item-select' : ''
            "
            >{{ item.title }}</span
          >
          <div
            class="app-menu-item-child"
            v-if="item.child"
            v-for="(item2, index2) in item.child"
            :key="index2"
            @click.stop="jumpRouter(item.path, item2.id)"
          >
            <span
              :class="
                selfPath == item.path && selfId == item2.id
                  ? 'app-menu-item-select'
                  : ''
              "
              >{{ item2.name }}</span
            >
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
  
  <script>
import { outloginApi, createRenewOrder, jsPays } from "@/api/g_login";
import { getForm } from "@/api/gwxx";
export default {
  data() {
    return {
      login_status: localStorage.getItem("foregroundToken"),
      selfPath: "/indexPage",
      selfId: "1",
      tabbar_list: [
        // {
        //   title:'搜索',
        //   path:'/searchPage'
        // },
        // {
        //   title:'首页',
        //   path:'/indexPage'
        // },
        {
          title: this.$wangzhan.name == "安徽" ? "学会概况" : "协会概况",
          path: "/surveyPage",
          child: [
            {
              name: this.$wangzhan.name == "安徽" ? "学会简介" : "协会简介",
              id: "1",
            },
            {
              name: this.$wangzhan.name == "安徽" ? "学会章程" : "协会章程",
              id: "2",
            },
            { name: "组织机构", id: "3" },
            { name: "理事会", id: "4" },
          ],
        },
        {
          title: "新闻动态",
          path: "/newsPage",
          child: [
            {
              name: this.$wangzhan.name == "安徽" ? "学会动态" : "协会动态",
              id: "1",
            },
            { name: "通知公告", id: "2" },
            { name: "行业新闻", id: "3" },
          ],
        },
        {
          title: "课程与活动",
          path: "/coursePage",
        },
        {
          title: "学术交流",
          path: "/sciencePage",
        },
        {
          title: "科学普及",
          path: "/popularizationPage",
        },
        {
          title: "会员中心",
          path: "/memberPage",
          child: [
            { name: "证书查询", id: "1" },
            { name: "会员查询", id: "2" },
          ],
        },
        {
          title: "培训基地管理",
          path: "/matrixPage",
          child: [
            { name: "考试管理", id: "1" },
            // {name:'培训基地',id:'2'},
          ],
        },
        {
          title: this.$wangzhan.name == "安徽" ? "学会党建" : "协会党建",
          path: "/associationPage",
          child: [{ name: "党建", id: "1" }],
        },
        {
          title: "互动交流",
          path: "/interactPage",
          child: [{ name: "联系方式", id: "1" }],
        },
      ],
      drawer: false,
      identity: localStorage.getItem("identity"),
      llll: {},
      payCode: "",
      tab: "",
      orderNo: "",
    };
  },
  created() {
    // let index = this.tabbar_list.findIndex( item => item.path == '/memberPage')
    // if(this.identity=='admin'){
    //   this.tabbar_list[index].child = [
    //     {name:'会员管理',id:'1'},
    //     {name:'证书管理',id:'2'}
    //   ]
    // }else{
    //   this.tabbar_list[index].child = [
    //     {name:'证书查询',id:'1'},
    //     {name:'会员查询',id:'2'}
    //   ]
    // }
  },
  mounted() {
    this.tab = localStorage.getItem("tab");
    console.log("moveTab", this.tab);
    this.selfPath = this.$route.path;
    this.selfId = this.$route.query.id;
    getForm().then((res) => {
      this.llll = JSON.parse(res.data);
    });

    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("micromessenger") !== -1) {
      const lujing = window.location.href;
      this.payCode = lujing.match(/code=(\S*)&state/)[1];
    }
  },
  watch: {
    $route(to) {
      this.selfPath = to.path;
      this.selfId = this.$route.query.id;
    },
  },
  methods: {
    jumpRouter(path, id = 1) {
      this.$router.push({ path, query: { id: id } });
      this.selfPath = path;
      this.drawer = false;
    },
    jumpLogin(tab) {
      // var userAgent = navigator.userAgent.toLowerCase();
      // if(tab==1&&userAgent.indexOf('micromessenger') !== -1){
      //   window.location.href = this.$baseUrl+'/api/wx/jsPay'
      // }else{
      this.$router.push({ path: "/loginPage", query: { tab } });
      location.reload();
      // }
    },
    outLogin() {
      this.$confirm("确定退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        outloginApi().then((res) => {
          this.$message({ message: res.message, type: "success" });
          const identity = localStorage.getItem("identity");
          this.$router.push({
            path: "/loginPage",
            query: { tab: identity == "admin" ? 2 : 0 },
          });
          localStorage.setItem("foregroundToken", "");
          localStorage.setItem("identity", "");
        });
      });
    },
    renew() {
      const tab = localStorage.getItem("tab");
      console.log("续费移动 - tab值:", tab);

      let type = "";
      if (tab === "0") {
        type = "member";
      } else if (tab === "3") {
        type = "memberUnits";
      } else {
        console.error("无效的tab值:", tab);
        this.$message({ message: "无效的续费类型", type: "error" });
        return;
      }

      createRenewOrder({
        type: type,
      })
        .then((res) => {
          console.log("续费接口响应:", res);
          if (res.code == 200) {
            // this.$message({ message: res.message, type: "success" });
            this.orderNo = res.data.orderNo;
            this.jsPays();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        })
        .catch((error) => {
          console.error("续费接口错误:", error);
          this.$message({ message: error.message, type: "error" });
        });
    },
    jsPays() {
      jsPays({ orderNo: this.orderNo })
        .then((res) => {
          console.log("获取支付授权URL:", res);
          // if (res.code === 200) {
            // window.location.href = res.data.redirectUri;
            window.location.href = res.data.redirectUri;
          // }
        })
        .catch((error) => {
          console.error("获取支付授权URL失败:", error);
          this.$message({ message: "获取支付链接失败", type: "error" });
        });
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
  <style scoped lang="css" src="../assets/css/base.css" />
  <style>
.nav-tabbar .el-menu--horizontal > .el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 0 29px;
  color: #000;
}
.nav-tabbar .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
  margin: 0 29px;
  color: #000;
}
.nav-tabbar .el-dropdown-menu__item,
.el-menu-item {
  font-size: 18px !important;
  font-weight: 600;
  border: none;
  height: 50px !important;
  background-color: #ffffffb7;
}
.nav-tabbar .el-submenu__title {
  font-size: 18px !important;
  font-weight: 600;
  border: none;
}
.nav-tabbar .el-menu.el-menu--horizontal {
  border: none;
}
.nav-tabbar .el-menu--horizontal > .el-menu-item.is-active {
  /* border-bottom: 3px solid transparent */
  border-bottom: none !important;
  border-color: #fff !important;
}
.nav-tabbar .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  /* border-bottom: 3px solid transparent; */
  border-bottom: none !important;
  border-color: #fff !important;
}
.nav-tabbar .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  display: none;
}

.menu-child {
  width: 100%;
  height: 100%;
  font-size: 16px;
  font-weight: 400;
  color: #000;
}
</style>